<rt-dialog-header
  [heading]="'tlc.positions.import_skills_flow.upload_file.heading' | translate"
  [subheading]="'tlc.positions.import_skills_flow.upload_file.heading' | translate"
/>

<rt-dialog-body variant="white">
  <tl-stepper [steps]="steps" />

  @if (messages().length > 0) {
    <div class="summary-section">
      <div class="text-container">
        <div class="section-heading">
          <rt-ai-logo size="small-x" />
          <span>{{
            'tlc.positions.import_skills_flow.summary_dialog.summary.heading' | translate
          }}</span>
        </div>
        <span class="skills-positions-count">{{
          'tlc.positions.import_skills_flow.summary_dialog.summary.skills_positions_count'
            | translate
              : {
                  skillsCount: skillsCount(),
                  positionsCount: positionsCount(),
                }
        }}</span>
        <span>{{
          'tlc.positions.import_skills_flow.summary_dialog.summary.analyzed_successfully'
            | translate
        }}</span>
        <span class="skills-analysis">{{
          'tlc.positions.import_skills_flow.summary_dialog.summary.skills_analysis' | translate
        }}</span>
      </div>

      @if (positiveAndInfoMessages().length > 0) {
        <div class="message-list">
          @for (message of positiveAndInfoMessages(); track $index) {
            <div class="message-item">
              <rt-icon
                [name]="messageIconConfig[message.type].name"
                [colorToken]="messageIconConfig[message.type].colorToken"
                size="small"
              />
              <span class="message-text" [innerHTML]="message.sanitizedText"></span>
            </div>
          }
        </div>
      }
      @if (warningMessages().length > 0) {
        <div class="attention-subsection">
          <span class="attention-heading">
            {{
              'tlc.positions.import_skills_flow.summary_dialog.summary.attention_heading'
                | translate
            }}
          </span>
          <div class="message-list">
            @for (message of warningMessages(); track $index) {
              <div class="message-item">
                <rt-icon
                  [name]="messageIconConfig[message.type].name"
                  [colorToken]="messageIconConfig[message.type].colorToken"
                  size="small"
                />
                <span class="message-text" [innerHTML]="message.sanitizedText"></span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  @for (message of blockingErrorMessages(); track $index) {
    <rt-infobox type="error" [isDismissible]="false" [heading]="message.text" />
  }

  @if (newPositions().length > 0) {
    <div class="new-positions-section">
      <rt-heading variant="heading bold"
        >{{ 'tlc.positions.import_skills_flow.summary_dialog.new_positions.heading' | translate }}
      </rt-heading>
      <span>{{
        'tlc.positions.import_skills_flow.summary_dialog.new_positions.subheading' | translate
      }}</span>
      <div class="position-tags">
        <div class="tags-container">
          @for (position of newPositions(); track $index) {
            <span class="position-tag">{{ position.name }}</span>
          }
        </div>
        <rt-group class="radio-group" variant="vertical stacked">
          <rt-radio
            [hasLensIcon]="true"
            [checked]="addNewPositions()"
            (click)="addNewPositions.set(true)"
          >
            {{
              'tlc.positions.import_skills_flow.summary_dialog.new_positions.add_option' | translate
            }}
          </rt-radio>
          <rt-radio
            [hasLensIcon]="true"
            [checked]="!addNewPositions()"
            (click)="addNewPositions.set(false)"
          >
            {{
              'tlc.positions.import_skills_flow.summary_dialog.new_positions.skip_option'
                | translate
            }}
          </rt-radio>
        </rt-group>
      </div>
    </div>
  }

  <div class="review-skills-section">
    <rt-heading variant="heading bold">
      {{ 'tlc.positions.import_skills_flow.summary_dialog.review_skills.heading' | translate }}
    </rt-heading>
    <span>
      {{ 'tlc.positions.import_skills_flow.summary_dialog.review_skills.subheading' | translate }}
    </span>

    @for (skill of skills(); track $index; let index = $index) {
      <tlc-imported-skill-card
        [skill]="skill"
        [groups]="groups()"
        [positions]="positions()"
        (skillSave)="onSkillSave(index, $event)"
        (proficiencySave)="onProficiencySave(index, $event)"
        (importDecisionChange)="onImportDecisionChange(index, $event)"
      />
    }
  </div>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button variant="primary" [loading]="isApplying()" (click)="applyImport()">
    <rt-icon name="check" />
    <span>{{
      'tlc.positions.import_skills_flow.summary_dialog.import_and_apply_changes' | translate
    }}</span>
  </rt-button>
</rt-dialog-footer>
